import React, { useState } from 'react';
import './task-add-form.css';
import { Button } from 'reactstrap';
import { func } from 'prop-types';

const TaskAddForm = ({ onAdd }) => {
  const [text, setText] = useState('')

  const onValueChange = ({ target: { value } }) => setText(value)

  const onSubmit = event => {
    event.preventDefault()

    if (text.trim().length) {
      onAdd(text)
    }
    setText('')
  }

  return (
    <form
      className="bottom-panel d-flex"
      onSubmit={event => onSubmit(event)}
    >
      <input
        type="text"
        placeholder="Текст новой задачи на выполнение"
        className="form-control new-task-label"
        onChange={event => onValueChange(event)}
        value={text}
      />
      <Button outline color="secondary">Добавить</Button>
    </form>
  )
}

export default TaskAddForm

TaskAddForm.propTypes = {
  onAdd: func,
}

TaskAddForm.defaultProps = {
  onAdd: () => { },
}

